import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getProducts, searchProductsAPI } from "../../services/api";

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getProducts(params);
      // console.log(response.data);

      return {
        slug: params.sub_category || params.type,
        data: response.data.product || [],
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Something went wrong"
      );
    }
  }
);
export const searchProducts = createAsyncThunk(
  "products/search",
  async (searchKey, { rejectWithValue }) => {
    try {
      const searchResults = await searchProductsAPI(searchKey)
      return searchResults.data
    }
    catch (error) {
      return rejectWithValue(error.message);
    }
  }
)
const productSlice = createSlice({
  name: "products",

  initialState: {
    productData: {},
    searchResults: [],
    loading: false,
    searchLoading: false,
    error: null
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;

        state.productData[action.payload.slug] =
          action.payload.data;
      })

      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(searchProducts.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(searchProducts.fulfilled, (state, action) => {
        state.searchLoading = false;
        state.searchResults = action.payload.products;
      })
      .addCase(searchProducts.rejected, (state, action) => {
        state.searchLoading = false;
        state.error = action.payload;
      });
  },
});

export default productSlice.reducer;